module.exports = __webpack_public_path__ + "img/首页头图1.806046d7.jpg";